import "@/index.css";
import { AppProviders } from "@/providers/app-providers";
import { AppRouter } from "@/routes";

export function App() {
  return (
    <AppProviders>
      <AppRouter />
    </AppProviders>
  );
}

export default App;
